<template>
  <div>
    <div
      style="width: 25%; margin: auto"
      v-if="(currentUserType > -1) & (currentUser.userType.name !== 'Lender')"
    >
      Search for logbook
      <hilo-select
        v-model="displayUser"
        :options="selectableUsers"
        @change="getLogbook"
      ></hilo-select>
    </div>
    <div v-if="displayUser">
      <div class="d-flex justify-content-between align-items-start mb-2">
        <!--        <hilo-button label="Add +" />-->
        <!-- @click="navigateToAddStudent"-->
        <h1 style="margin: 0 0 4px">Logbook</h1>
        <input
          class="search-input"
          v-model="search"
          placeholder="Search"
          @input="filterEntries"
        />
      </div>
      <hilo-table
        :columns="columns"
        :data="filteredEntries"
        :rowClass="getRowClass"
      />
    </div>
    <!-- <card>
      <div class="row">
        <div class="custom-txt mb-2 ml-4 mt-1">Logbook</div>
        <card class="sml-card mr-2" style="margin-left: 430px;">
          Total Hours: 1200
        </card>
        <card class="sml-card mr-2">
          Total PIC: 1200
        </card>
        <card class="sml-card mr-2">
          Total Dual: 1200
        </card>
        <card class="sml-card mr-2">
          Total IFR: 1200
        </card>
        <card class="sml-card mr-2">
          Total Day: 1200
        </card>
        <card class="sml-card mr-2">
          Total Nights: 1200
        </card>
      </div> -->
    <!--<div class="row" style="margin-top: -20px;">
         <card class="card-width ml-2">
          <div>(First Name's) Logbook
            <button class="ml-3" type="button">Add +</button>
          </div>
          <div class="row">
            <div class="col-sm-12 mt-2">
              <el-input
                v-model="searchQuery"
                placeholder="Search"
                clearable
                @clear="searchQuery = ''">
                <span slot="prepend">Search</span>
              </el-input>
            </div>
          </div>
          <div class="ml-2 mt-2">Recent Flights</div>
          <hr>
          <div class="row">
            <div class="col-sm-6">
              <div>AZ39-KFFZ</div>
              <div class="small-txt">N2361R</div>
              <div class="red-txt" style="font-size: 12px;">Draft From Hilo Log</div>
            </div>
            <div class="col-sm-6">
              <div class="small-txt txt-align">May 13 2024</div>
              <br>
              <div class="small-txt txt-align" style="margin-top: -20px;">1.8 Total</div>
            </div>
          </div>
          <el-button class="mb-2" style="margin-left: -10px;" @click="searchQuery = ''">Clear</el-button>
        </card>
        <card class="card-width ml-2">
          <div>Menu</div>
          <hr>
          <div class="row">
            <i class="fa-regular fa-file-lines mt-1 ml-3"></i>
            <div class="ml-1">Reports</div>
          </div>
          <hr>
          <div class="row">
            <i class="fa-solid fa-plane rotate ml-3"></i>
            <div class="ml-1">Aircraft</div>
          </div>
          <hr>
          <div class="row">
            <i class="fa-solid fa-user-group ml-3"></i>
            <div class="ml-1">Instructors</div>
          </div>
          <hr>
          <div class="row">
            <i class="fa-regular fa-circle-check ml-3"></i>
            <div class="ml-1">Endorsements</div>
          </div>
          <hr>
          <div class="row">
            <i class="fa-solid fa-screwdriver-wrench ml-3"></i>
            <div class="ml-1 mb-1">Instructor Tools</div>
          </div>
        </card>
        <card class="card-width ml-2">
          <div class="row">
            <div class="ml-2">Currency Summary</div>
          </div>
          <hr>
          <div class="row">
            <div class="col-sm-6">
              <div>Flight Review</div>
            </div>
            <div class="col-sm-6">
              <div class="red-txt txt-align">0 Days</div>
              <div class="small-txt txt-align">Remaining</div>
            </div>
          </div>
            <div class="red-txt small-txt" style="margin-top: -15px;">Not Current</div>
          <hr>
          <div class="row">
            <div class="col-sm-6">
              <div>Medical</div>
            </div>
            <div class="col-sm-6">
              <div class="red-txt txt-align">0 Days</div>
              <div class="small-txt txt-align">Remaining</div>
            </div>
          </div>
          <div class="red-txt small-txt" style="margin-top: -15px;">Not Current</div>
          <hr>
          <div class="row">
            <div class="col-sm-6">
              <div>IFR (Airplane)</div>
            </div>
            <div class="col-sm-6">
              <div class="red-txt txt-align">0 Days</div>
              <div class="small-txt txt-align">Remaining</div>
            </div>
          </div>
          <div class="red-txt small-txt" style="margin-top: -15px;">Not Current</div>
          <hr>
          <div class="row">
            <div class="col-sm-6">
              <div>General (ASEL)</div>
            </div>
            <div class="col-sm-6">
              <div class="red-txt txt-align">0 Days</div>
              <div class="small-txt txt-align">Remaining</div>
            </div>
          </div>
          <div class="red-txt small-txt" style="margin-top: -15px;">Not Current</div>
        </card>
      </div>
      <card>
         <div class="row mb-2">
          <div class="custom-text ml-3 mt-1">Logbook</div>
          <div class="col-sm-5 mb-2">
            <el-input
              v-model="searchQuery"
              placeholder="Search"
              clearable
              @clear="searchQuery = ''">
              <span slot="prepend">Search</span>
            </el-input>
          </div>
          <el-button class="mb-2" style="margin-left: -10px;" @click="searchQuery = ''">Clear</el-button>
            <button type="button" class="mb-2" style="margin-left: 555px;">Print Logbook</button>
        </div>
        <el-pagination
          class="txt-align"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="pageSizes"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalItems">
        </el-pagination>
        <div style="margin-left: 285px; margin-top: -25px;">
          <div class="row">
            <div>Page Total</div>
          </div>
          <div class="row">
            <div>Amount Forward</div>
          </div>
          <div class="row">
            <div>Total to Date</div>
          </div>
        </div>
      </card>
    </card> -->
  </div>
</template>
<script>
//import { Pagination, Button } from 'element-ui';
import HiloTable from "src/components/HiloComponents/HiloTable.vue";
import LogbookAPIService from "../../../servicehandlers/LogbookAPIService.js";
import dayjs from "dayjs";
const logbookAPIService = new LogbookAPIService();
import { useLoginStore } from "@/stores/loginStore";
import HiloSelect from "../../../components/HiloComponents/HiloSelect.vue";
import ActiveInstructorsAPIService from "../../../servicehandlers/ActiveInstructorsAPIService";
const activeInstructorsAPIService = new ActiveInstructorsAPIService();
import ActiveStudentsAPIService from "../../../servicehandlers/ActiveStudentsAPIService";
const activeStudentsAPIService = new ActiveStudentsAPIService();

export default {
  components: {
    HiloSelect,
    HiloTable,
    // [Pagination.name]: Pagination,
    // [Button.name]: Button,
  },
  data() {
    return {
      entries: [],
      filteredEntries: [],
      search: "",
      columns: [
        { key: "date", label: "Date" },
        { key: "aircraft", label: "Aircraft" },
        { key: "tail", label: "Tail" },
        // { key: "from", label: "From" },
        // { key: "to", label: "To" },
        { key: "sel", label: "SEL" },
        { key: "mel", label: "MEL" },
        { key: "sim", label: "Sim" },
        { key: "dualTime", label: "Dual" },
        { key: "pic", label: "PIC" },
        { key: "day", label: "Day" },
        { key: "night", label: "Night" },
        { key: "ground", label: "Ground" },
        // { key: "cross_country", label: "Cross Country" },
        // { key: "actual_instr", label: "Actual Instr" },
        // { key: "simulated_instr", label: "Simulated Instr" },
        // { key: "no_instr_appr", label: "NO. Instr. Appr." },
        // { key: "no_ldg", label: "NO. LDG." },
        { key: "totalTime", label: "Total Flight Time" },
        // { key: "remarks", label: "Remarks" },
      ],
      currentUser: null,
      displayUser: null,
      currentUserType: null,
      selectableUsers: [],

      // searchQuery: '',
      // currentPage: 1,
      // perPage: 50,
      // pageSize: 20,
      // pageSizes: [20, 50, 100, 200, 500, 1000],
      // totalItems: 0,
      // data: '',
      // success_txt: '',
      // error_txt: '',

      // modals: {
      //   error: false,
      //   success: false,
      // }
    };
  },
  // watch: {
  //   filteredEntries: {
  //     handler(newVal) {
  //       this.totalItems = newVal.length;
  //     },
  //     immediate: true
  //   }
  // },
  // computed: {
  //   paginatedUsers() {
  //     const start = (this.currentPage - 1) * this.pageSize;
  //     const end = this.currentPage * this.pageSize;
  //     return this.filteredUsers.slice(start, end);
  //   },
  // },
  async mounted() {
    this.currentUser = useLoginStore().getUser;
    if (this.$route.query.userId) {
      this.displayUser = this.$route.query.userId;
      this.getLogbook();
    } else {
      this.getUserType();
    }
  },
  methods: {
    async getLogbook() {
      if (this.displayUser) {
        const response = await logbookAPIService.getByUserId(
          this.displayUser,
          this.$router,
        );
        this.entries = response.map((entry) => {
          const formatValue = (value) =>
            value ? parseFloat(value).toFixed(1) : "0";

          return {
            ...entry,
            date: entry.isTotal
              ? "Total"
              : dayjs(entry.createdAt).format("MM/DD/YY, h:mm a"),
            aircraft: entry.aircraft?.model || "-",
            tail: entry.aircraft?.tailNumber || "-",
            sel: formatValue(entry.sel),
            mel: formatValue(entry.mel),
            sim: formatValue(entry.sim),
            dualTime: formatValue(entry.dualTime),
            pic: formatValue(entry.pic),
            day: formatValue(entry.day),
            night: formatValue(entry.night),
            ground: formatValue(entry.ground),
            totalTime: formatValue(
              (parseFloat(entry.sel) || 0) +
                (parseFloat(entry.mel) || 0) +
                (parseFloat(entry.sim) || 0),
            ),
          };
        });
        this.filteredEntries = this.entries;
      }
    },
    getUserType() {
      for (let group of this.currentUser.auth_groups) {
        if (group.name === "Admins") {
          this.currentUserType = 1;
          this.getActiveInstructors();
          this.getActiveStudents();
          break;
        } else if (group.name === "Instructors") {
          this.currentUserType = 0;
          this.getActiveStudents();
          this.displayUser = this.currentUser.id;
          this.getLogbook();
        } else if (group.name === "Students") {
          this.currentUserType = -1;
          this.displayUser = this.currentUser.id;
          this.getLogbook();
        }
        if (group.name === "Owner") {
          this.currentUserType = 11;
          this.getActiveInstructors();
          this.getActiveStudents();
          //this.displayUser = this.currentUser.id;
          //this.getLogbook();
          break;
        }
      }
    },
    getActiveInstructors() {
      return activeInstructorsAPIService.get(this.$router).then((response) => {
        for (let user of response) {
          if (!this.selectableUsers.find((data) => data.id === user.userId)) {
            let temp = {
              id: user.userId,
              name: user.user.firstName + " " + user.user.lastName,
            };
            this.selectableUsers.push(temp);
          }
        }
      });
    },
    getActiveStudents() {
      return activeStudentsAPIService.get(this.$router).then((response) => {
        for (let user of response) {
          if (!this.selectableUsers.find((data) => data.id === user.userId)) {
            let temp = {
              id: user.userId,
              name: user.user.firstName + " " + user.user.lastName,
            };
            this.selectableUsers.push(temp);
          }
        }
      });
    },
    filterEntries() {
      const searchTerm = this.search.toLowerCase();
      const columnKeys = this.columns.map((column) => column.key);
      this.filteredEntries = this.entries.filter((entry) => {
        return columnKeys.some((key) => {
          const value = entry[key];
          return value && value.toString().toLowerCase().includes(searchTerm);
        });
      });
    },
    getRowClass(row) {
      return row.isTotal ? "total-row" : "";
    },
    // handleSizeChange(newSize) {
    //   this.pageSize = newSize;
    //   this.currentPage = 1;
    // },
    // handleCurrentChange(newPage) {
    //   this.currentPage = newPage;
    // },
    // handleSuccess(text) {
    //   this.success_txt = text;
    //   this.openModal('success');
    //   this.spinning = false;
    //   setTimeout(() => {
    //     this.modals['success'] = false;
    //   }, 1500); // Hide after 1.5 secs
    // },
    // handleError(error) {
    //   this.error_txt = error;
    //   this.openModal('error');
    //   this.spinning = false;
    //   setTimeout(() => {
    //     this.modals['error'] = false;
    //   }, 1500); // Hide after 1.5 secs
    // },
    // closeModal(name) {
    //   this.modals[name] = false;
    // },
    // openModal(name) {
    //   this.modals[name] = true;
    // },
  },
};
</script>
<style>
/*noinspection CssUnusedSymbol */
.total-row {
  background-color: lightblue;
}
.hilo-table .total-row td {
  font-weight: bold;
}
/* .table-container {

}
.custom-txt {
  color: dimgray;
  font-size: 25px;
}
.custom-text {
  color: dimgray;
  font-size: 20px;
}
.card-width {
  width: 300px;
}
.red-txt {
  color: brown;
}
.small-txt {
  font-size: 10px;
}
.txt-align {
  text-align: right;
}
.sml-card {
  width: 145px;
  font-size: 13px;
}
.rotate {
  transform: rotate(-30deg);
} */
</style>
